<template>
  <div class="sub-contain">
    <div id = "left-image" >
       <div class="icon-show imageshow"></div>
    </div>
  </div>
</template>

<script>
export default {
  
};
</script>

<style lang="scss" scoped>
/* 加入css代码仅是为了使界面更加直观 */



.sub-contain {
  height: 500px;
  width: 100%;
  padding: 20px;
  text-align: center;
//   margin-top: 20px;
  background-color: #1f6fb5;
//   color: #fff;
  opacity:0.8;
}
.imageshow{
    padding: 0;
    margin: 0;
 height: 470px;
  width: 50%;

}
</style>